import { memo } from 'react';

import { useCaptureException } from '@zenbusiness/application-commons-logging';
import PropTypes from 'prop-types';

import { IS_THAT_CORRECT_STEP } from '#client/constants/application';
import {
  CONFIRMATION_FORM_STEP,
  HOW_MUCH_STEP,
  WHICH_ACCOUNT_STEP
} from '#client/constants/transfer';
import useModalContext from '#client/hooks/useModalContext';
import useToastContext from '#client/hooks/useToastContext';

import ConfirmationForm from './ConfirmationForm';
import HowMuchForm from './HowMuchForm';
import IsThisCorrectFormV2 from './IsThisCorrectFormv2';
import WhichAccountForm from './WhichAccountForm';

const CurrentStep = ({ isHandling = false, closeHandler, currentFormStep }) => {
  const { createCommonErrorToast } = useToastContext();
  const { clearAllModal } = useModalContext();
  const captureException = useCaptureException();
  const stepNotMatchHandler = () => {
    captureException(
      new Error(`Form step is not correct with currentFormStep: ${currentFormStep}`),
      {
        level: 'warning'
      }
    );
    createCommonErrorToast();
    return null;
  };

  const renderCurrentStep = () => {
    switch (currentFormStep) {
      case WHICH_ACCOUNT_STEP:
        return (
          <WhichAccountForm
            handleClose={closeHandler}
            isHandling={isHandling}
          />
        );
      case HOW_MUCH_STEP:
        return <HowMuchForm handleClose={closeHandler} />;
      case IS_THAT_CORRECT_STEP:
        return <IsThisCorrectFormV2 handleClose={closeHandler} />;
      case CONFIRMATION_FORM_STEP:
        return (
          <ConfirmationForm
            handleClose={closeHandler}
            handleClosePreviousModal={clearAllModal}
          />
        );
      default:
        // show error toast and report error log
        return stepNotMatchHandler();
    }
  };

  return <>{renderCurrentStep()}</>;
};

const areEqual = (preProp, nextProp) =>
  preProp.isHandling === nextProp.isHandling &&
  preProp.currentFormStep === nextProp.currentFormStep;

CurrentStep.propTypes = {
  isHandling: PropTypes.bool,
  closeHandler: PropTypes.func.isRequired,
  currentFormStep: PropTypes.string.isRequired
};

export default memo(CurrentStep, areEqual);
